<template>
  <div class="app-menu">
    <button
      class="hamburger hamburger--spin"
      :class="{'is-active':menuOpen}"
      type="button"
      @click="menuToggle"
    >
      <span class="hamburger-box">
        <span class="hamburger-inner"></span>
      </span>
    </button>
    <div
      class="menu-container"
      :class="{'menu-is-active':menuOpen}"
    >
      <ul class="reset nav-list">
        <li>
          <router-link to="/" class="nav-link">Home</router-link>
        </li>
        <li>
          <router-link to="/themepark" class="nav-link">Theme Park Calculator</router-link>
        </li>
        <li>
          <router-link to="/museum" class="nav-link">Museum Calculator</router-link>
        </li>
        <li>
          <router-link to="/freeform" class="nav-link">Free Form Calculator</router-link>
        </li>
        <li>
          <router-link to="/buzz" class="nav-link">Who Is Buzz Price</router-link>
        </li>
        <li>
          <router-link to="/about" class="nav-link">About Ask Buzz</router-link>
        </li>
        <li>
          <router-link to="/creators" class="nav-link">The Creators</router-link>
        </li>
        <li>
          <router-link to="/disclaimer" class="nav-link">Roller Coaster Math Disclaimer</router-link>
        </li>
      </ul>
      <div class="d-flex justify-content-center pb-x2 align-items-start">
        <img class="menu-logo" src="~@/assets/askbuzz-transparent.png">
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menuOpen: false
    }
  },
  components: {
  },
  props: {},
  watch: {},
  created () {},
  mounted () {},
  computed: {},
  methods: {
    menuToggle () {
      this.menuOpen = !this.menuOpen
    }
  }
}
</script>

<style scoped lang="scss">
.menu-container{
  position: fixed;
  z-index: 100;
  top: 0px;
  left: -380px;
  height: 100vh;
  width: 100vw;
  max-width: 360px;
  transition: left .32s ease-in-out;
  color: #fff;
  background: #6C90B2;
  padding: 16px;
  box-shadow: 2px 0px 8px 0px rgba(81,119,155,0.6);
  ul.nav-list{
    margin-top: 120px;
    width: 100%;
    li{
      margin-bottom: 32px;
      text-align: center;
      a, .nav-link {
        text-decoration: none;
        color: #fff;
        font-size: 16px;
        line-height: 20px;
        display: inline-block;
        &.nav-link-disabled {
          opacity: .6;
        }
        &.router-link-exact-active{
          font-weight: 500;
          border-bottom: solid 1px #fff;
          cursor: default;
        }
      }
    }
  }
  .menu-logo{
    width: 80px;
    height: auto;
  }
  &.menu-is-active{
    left: 0px;
  }
}
// X animations
.hamburger {
  height: 44px;
  width: 44px;
  padding: 13px 10px;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
  border-radius: 50%;
  background: #6C90B2;
  position: fixed;
  z-index: 110;
  top: 12px;
  left: 12px;
}
// .hamburger:hover {
//   // opacity: 0.7;
// }
// .hamburger.is-active:hover {
//   // opacity: 0.7;
// }
.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner::before,
.hamburger.is-active .hamburger-inner::after {
  background-color: #fff;
}

.hamburger-box {
  width: 24px;
  height: 20px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -2px;
}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 24px;
  height: 2px;
  background-color: #fff;
  border-radius: 4px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.1s;
  transition-timing-function: ease;
}
.hamburger-inner::before, .hamburger-inner::after {
  content: "";
  display: block;
}
.hamburger-inner::before {
  top: -8px;
}
.hamburger-inner::after {
  bottom: -8px;
}
//  spin
.hamburger--spin .hamburger-inner {
  transition-duration: 0.14s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.hamburger--spin .hamburger-inner::before {
  transition: top 0.1s 0.1s ease-in, opacity 0.1s ease-in;
}
.hamburger--spin .hamburger-inner::after {
  transition: bottom 0.1s 0.1s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.hamburger--spin.is-active .hamburger-inner {
  transform: rotate(225deg);
  transition-delay: 0.1s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
.hamburger--spin.is-active .hamburger-inner::before {
  top: 0;
  opacity: 0;
  transition: top 0.1s ease-out, opacity 0.1s 0.12s ease-out;
}
.hamburger--spin.is-active .hamburger-inner::after {
  bottom: 0;
  transform: rotate(-90deg);
  transition: bottom 0.1s ease-out, transform 0.22s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
}

// media queries
// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
